<template>
  <div class="collectionNavCategory myCollectionCategory"
    :style="categoryStyle">
    <div class="categoryWrap"
      v-if="!isMegaMenu"
      :style="listStyle">
      <div class="categoryList" :style="categoryHeight">
        <router-link
          v-for="item in categoryList"
          :key="item.categoryId"
          :to="{params: { ...$route.params, categoryId: item.categoryId }}"
          :class="{active: isActive(item)}"
          class="categoryItem">
          <span class="name" :style="fontStyle">{{ item.categoryLabel[lang] }}</span>
        </router-link>
      </div>
    </div>
    <div v-if="!isMegaMenu && subCategory"
      class="subCategory"
      :style="subCategoryStyle">
      <router-link
        v-for="item in subCategory"
        :key="item.categoryId"
        :to="{params: { ...$route.params, categoryId: item.categoryId }}"
        class="categoryItem">
        <span class="name">{{ item.categoryLabel[lang] }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionCategory',
  props: [
    'locale',
    'lang',
    'pageId',
    'setting'
  ],
  computed: {
    isMegaMenu () {
      return this.$store.getters['collection/getMegaMenu']
    },
    categoryHeight () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        height: `${category && category.height}px`
      }
    },
    categoryStyle () {
      const setting = this.setting
      const category = setting && setting.category
      const frame = this.$store.getters['collection/getPageFrame']
      return {
        backgroundColor: this.isIntro ? 'transparent' : category && category.backgroundColor,
        ...frame && {
          paddingLeft: `${frame}px`,
          paddingRight: `${frame}px`
        }
      }
    },
    listStyle () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        borderColor: this.isIntro ? 'transparent' : category && category.borderColor,
      }
    },
    fontStyle () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        borderColor: category && category.text && category.text.color
      }
    },
    subCategoryStyle () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        backgroundColor: category && category.backgroundColor,
        height: `${category && category.height}px`
      }
    },
    categoryList () {
      const categoryId = this.$route.params.categoryId
      const list = this.$store.getters['collection/getMyCollectionCategory'](categoryId)
      return list.map(x => {
        return {
          ...x,
          ...x.subCategory && {
            categoryId: x.subCategory[0].categoryId
          }
        }
      })
    },
    subCategory () {
      const categoryId = this.$route.params.categoryId
      const currentCategory = this.categoryList && this.categoryList.find(x => x.subCategory && x.subCategory.find(s => s.categoryId === categoryId))
      const subCategory = currentCategory && currentCategory.subCategory
      return subCategory
    }
  },
  beforeDestroy () {
    // const collectionNav = document.querySelector('.collectionNav')
    // collectionNav.style.marginBottom = ''
  },
  watch: {
    subCategory () {
      // const collectionNav = document.querySelector('.collectionNav')
      // const setting = this.setting
      // const category = setting && setting.category
      // const subCategoryHeight = `-${category && category.height}px`
      // collectionNav.style.marginBottom = collectionNav ? subCategoryHeight : ''
    }
  },
  mounted () {
    if (this.subCategory) {
      // const collectionNav = document.querySelector('.collectionNav')
      // const setting = this.setting
      // const category = setting && setting.category
      // const subCategoryHeight = `-${category && category.height}px`
      // collectionNav.style.marginBottom = collectionNav ? subCategoryHeight : ''
    }
  },
  methods: {
    categoryRouteInfo (categoryId) {
      const categoryItem = this.categoryList.find(x => x.categoryId === categoryId)
      const categoryRouteName = this.isMyCollection
        ? 'myCollection'
        : categoryItem.useMain
          ? 'collectionCategoryMain'
          : 'collectionPage'
      return {
        name: categoryRouteName,
        params: {
          ln: this.$route.params.ln,
          pageId: this.$route.params.pageId,
          categoryId: categoryId
        }
      }
    },
    isActive (item) {
      const categoryId = this.$route.params.categoryId
      return (item.categoryId === categoryId) || (item.subCategory && item.subCategory.find(x => x.categoryId === categoryId))
    }
  }
}
</script>